<template>
    <Editor_MN v-model="content" :init="config" style="width:98%"></Editor_MN>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "editor-demo_mn",
        data() {
            return {
				config: {
                    language: 'mn',
                    plugins: 'orhoncovertcode spellchecker mongolcharmap emoticons autolink link image imagetools textcolor lists print insertdatetime media table toc preview fullscreen paste preview topic',
                    toolbar1: 'undo redo | image | bold italic lists | paste pastetext emoticons | bullist | alignleft aligncenter alignright alignjustify  | forecolor topic ',
                    toolbar2: 'orhoncovertcode  spellchecker mongolcharmap | fontselect fontsizeselect | removeformat | link unlink | table | preview code',
                    
                    // 字体
                    fontsize_formats: '12px 14px 16px 18px 20px 22px 30px',
                    // 行高
                    lineheight_formats: "13 16px 18px 20px 23px 26px 30px 35px",
                    image_description: false,
                    content_css: '/static/tinymce/editor_style.css',
                    font_formats: "ᠣᠷᠬᠣᠨ ᠴᠠᠭᠠᠨ ᠲᠢᠭ=OrhonChaganTig;ᠣᠷᠬᠣᠨ ᠭᠠᠷᠴᠠᠭ ᠲᠢᠭ=OrhonChaganTig;ᠣᠷᠬᠣᠨ ᠬᠠᠸᠠᠩ ᠲᠢᠭ=OrhonHawangTig;",
                    paste_use_dialog : true,
                    paste_as_text: true,
                    paste_data_images: true,
                    paste_auto_cleanup_on_paste : true,
                    paste_convert_middot_lists : false,
                    images_upload_handler: (blobInfo, success, failure)=> {
                        let formData = new FormData();
                        formData.append('file', blobInfo.blob(), blobInfo.filename());
                          formData.append('apiterminal','Aqt_20230517ApiWeb');
                          formData.append('model',this.model?this.model:'');
                          formData.append('filetype','images');

                          
                        axios.post(this.uploadUrl,formData,{
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Authorization': 'Bearer '+this.uploadToken
                            }
                        }).then(res=> {
                            if(res.data.code==200) {
                                success(res.data.data.file_url);
                            } else {
                                failure(res.data.code+': '+res.data.message);
                            }
                            console.log(res)

                        }).catch(err=> {
                            console.log(err)
                            failure('fail: '+err);
                        })
                    },
                    editkatex: (latex)=> {
                        // this.$emit('editLatex',latex)
                        this.$formula({
                            exper: latex,
                            onInsert: (url,expr)=> {
                                tinymce.activeEditor.insertContent(`<img src="${url}" data-latex="${expr}">`);
                            }
                        })
                    },
                    toFormula: ()=> {
                        // this.$emit('formula')
                        this.$formula({
                            exper: '',
                            onInsert: (url,expr)=> {
                                tinymce.activeEditor.insertContent(`<img src="${url}" data-latex="${expr}">`);
                            }
                        })
                    },
                    toFiles: ()=> {
                        // this.$emit('files')
                        this.$files((data) => {
                            data.forEach(item => {
                                if (item.type == 'image') {
                                    tinymce.activeEditor.insertContent(`<span style="padding:10px"><img src="${item.src}"/></span>`)
                                }
                                if (item.type == 'video') {
                                    tinymce.activeEditor.insertContent(
                                    `<span style="padding:10px"><video controls="controls" width="350" height="180"><source src="${item.src}" /></video></span>`)
                                }
                            });
                        })
                    },
                    // 选中图片出现选项
                    imagetools_toolbar: "rotateleft rotateright imageoptions",
                    // 上传路径
                    images_upload_url: this.uploadUrl,
                    // 自动上传图片
                    automatic_uploads: false,
                    height: this.height,
                    // 隐藏bar栏
                    statusbar: false,
                    skin: 'custom',
                    menubar: false,
                    mobile: { theme: 'mobile' },
                    inline: this.inline?true:false
				}
            }
        },
        props: {
            value: {
                type: String,
                default: ''
            },
            uploadToken: {
                type: String,
                default: ''
            },
            uploadUrl: {
                type: String,
                default: ''
            },
            height: {
                type: Number,
                default: 500
            },
            inline: {
                type: Boolean,
                default: false
            },
            model: {
                type: [Boolean,String],
                default: false
            },
        },
        computed: {
            content: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input',val)
                }
            }
        },
        components: {
            'Editor_MN': Editor
        },
    }
</script>
